import { ReservationStatus } from '@user-history/entities/reservation-status';

export function isConfirmReservationByStatus(type: ReservationStatus): boolean {
  return type === ReservationStatus.Confirm || 
    type === ReservationStatus.Confirmed || 
    isOptimizingReservation(type);
}

export function isCancelledReservationByStatus(type: ReservationStatus): boolean {
  return type === ReservationStatus.Canceled || type === ReservationStatus.Cancelled;
}

export function isOptimizingReservation(type: ReservationStatus): boolean {
  return type === ReservationStatus.Optimizing || 
         type === '' as ReservationStatus;
}
